<template>
  <input
    ref="input"
    :value="modelValue"
    @input="onInput"
    @blur="onBlur"
    :disabled="disabled"
  >
</template>

<script>
  import { clearNumber } from '@/utils/formatting';

  export default {
    name: 'NumericInput',

    props: {
      modelValue: {
        required: true,
        type: null,
      },

      format: {
        required: false,
        type: String,
        default: '0.[00]',
      },

      blurFormat: {
        required: false,
        type: String,
        default: '0.00[00]',
      },

      formatOnBlur: {
        required: false,
        type: Boolean,
        default: false,
      },

      finalFormat: {
        required: false,
        type: Boolean,
        default: false,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      allowMinus: {
        required: false,
        type: Boolean,
        default: false,
      },
      allowNull: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    methods: {
      onBlur() {
        if (this.formatOnBlur && this.$refs.input) {
          this.$refs.input.value = clearNumber(this.modelValue, this.blurFormat);
        }
      },

      onInput(event) {
        const newValue = clearNumber(event.target.value, this.format, this.finalFormat, this.allowMinus, this.allowNull);
        this._updateInputValue(newValue);
      },

      _updateInputValue(value) {
        if (this.$refs.input) {
          this.$refs.input.value = value;
        }

        this.$emit('update:modelValue', value);
      },
    },
  };
</script>
